import { UserGroupIcon } from "@heroicons/react/24/outline";
import { formatRate } from "../../utils/formatRate";
import { pricingTheme, type PricingTone } from "./pricingTheme";
import { PricingSectionHeader, RateTable } from "./PricingSectionParts";
import type { PublicRateCard } from "./rateCardTypes";

interface Props {
    tone: PricingTone;
    card: PublicRateCard;
}

export default function CallCentreRates({ tone, card }: Props) {
    const t = pricingTheme(tone);
    const threshold = card.billing.callCentreAutoChargeAtMinor;

    return (
        <section aria-labelledby="pricing-call-centre" className={t.section}>
            <PricingSectionHeader
                tone={tone}
                icon={UserGroupIcon}
                id="pricing-call-centre"
                title="Call centre (your own agents)"
                subtitle="Ring groups, IVR menus, the dialer and the live floor for your human team. Open to every workspace with a number."
            />
            <RateTable tone={tone} lines={card.callCentre} caption="Call-centre rates" />
            <ul className={`mt-4 space-y-1 text-xs ${t.muted}`}>
                <li>Agent time is billed per started minute, inbound or outbound.</li>
                <li>
                    Billed on a balance of its own, separate from AI voice
                    {threshold ? ` — charged to your card at ${formatRate(threshold, card.currency)}` : ""}.
                </li>
                {!card.callCentre.some((l) => l.chargeType === "CALL_CENTRE_RENTAL") && (
                    <li>No monthly rental for numbers on the floor.</li>
                )}
            </ul>
        </section>
    );
}
